import { buildScopedI18n } from '../../../../../utils/buildScopedI18n';
import configAreasEsCL from './locales/es-CL.json';
import configAreasEnUS from './locales/en-US.json';
import configAreasPtBR from './locales/pt-BR.json';

export const configAreasI18n = buildScopedI18n({
  esCL: configAreasEsCL,
  enUS: configAreasEnUS,
  ptBR: configAreasPtBR,
});
